import { Spinner } from '@/components/loaders/Spinner';
import ShiplexLogo from '@/components/ui/ShiplexLogo';
import { type TranslationKey } from '@/i18n/i18n';
import { useTranslation } from 'react-i18next';

interface LoadingScreenProps {
  message?: TranslationKey;
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({ message }) => {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute top-4 left-4">
        <ShiplexLogo color="darkBlue" />
      </div>
      <div className="rounded-lg bg-white p-8">
        <div className="flex flex-col items-center space-y-4">
          {message && <p className="font-medium text-neutral-700">{t(message)}</p>}
          <Spinner size="lg" variant="default" />
        </div>
      </div>
    </div>
  );
};
